import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import {DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE, ROOM_TYPE_AMENITIES_MAX_OCCUPANCY, FORM_ROOM_TYPES_NAME, ROOM_TYPE_AMENITIES_CODES_MAX_OCCUPANCY} from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import StringConst from '../../../../constants/StringConst'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import RoomTypesService from '../../../../services/RoomTypesService'
import {isArrayNotEmpty, isHotelDomestic, isObjectEmpty, pad, searchFirstObjectInList, searchObjectListBoolean, sortObjectList} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import SelectList from '../../../atoms/form/SelectList/SelectList'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import Card from '../../../molecules/Card/Card'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import TextAreaInput from 'components/atoms/form/TextAreaInput/TextAreaInput'
import './RoomType.scss'

import EnvVarsConst from "../../../../constants/EnvVarsConst";


class RoomType extends Component {

    headers = ['Code', 'Description', 'Charge', 'Delete']

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)

        if (!hotelCode || !hotelInfo) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        // The individual room type which is being edited
        let roomType = this.props.history.location?.state?.roomType
        // The existing room types list
        let roomTypes = this.props.history.location?.state?.roomTypes

        // Check if a room type is being edited or a new room type is being added
        const isEdit = this.props.history.location?.state?.isEdit

        // Get existing room type codes to validate against new code
        let existingRoomTypeCodes
        if (isArrayNotEmpty(roomTypes)) {
            existingRoomTypeCodes = roomTypes.map(roomType => roomType.hotelRoomTypeCode)
            if (isEdit) {
                // When a room type is being edited, remove it's room type code from the list of existing room type codes
                existingRoomTypeCodes = existingRoomTypeCodes.filter(existingRoomTypeCode => existingRoomTypeCode !== roomType.hotelRoomTypeCode)
            }
        } else {
            existingRoomTypeCodes = []
        }

        // Check how many rooms can be added
        let maximumAllowedRoomCount = this.props.history.location?.state?.maximumAllowedRoomCount
        // If this value is not present, set it to 0
        if (maximumAllowedRoomCount === undefined) {
            maximumAllowedRoomCount = 0
        }

        const isDomestic = isHotelDomestic(hotelInfo)

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            isHotelDomestic: isDomestic,
            roomType: roomType,
            roomTypes: roomTypes,
            masterRoomAmenities: [],
            initialValues: roomType ? this.getInitialValues(roomType) : this.initialValues,
            initialValuesForRoomAmenities: roomType ? this.getInitialValuesForRoomAmenities(roomType) : this.initialValuesForRoomAmenities,
            isEdit: isEdit,
            editIndex: this.props.history.location?.state?.editIndex,
            maximumAllowedRoomCount: maximumAllowedRoomCount,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showExamples: false,
            showPopularAmenities: false,
            existingRoomTypeCodes: existingRoomTypeCodes,
            minRoomAmenitiesLimitReached: false,
            areaUnits: getSessionItem(SessionConst.AREA_UNIT),
        }
    }

    initialValuesForRoomAmenities = {
        searchKey: '',
        categoryCode: '',
        selectedRoomAmenities: [],
        addIndices: [],
        removeIndices: [],
        optionsList: [],
        filteredList: undefined,
        filterOptions: [{ label: '', value: '' }]
    }

    initialValues = {
        roomTypeCode: '',
        roomCategory: FormConst.DEFAULT_ROOM_TYPE,
        numberOfRooms: '',
        maxOccupancy: '',
        accessible: false,
        suite: false,
        smoking: false,
        efficiency: false,
        extraBedAllowed: false,
        numberOfKingBeds: 0,
        numberOfQueenBeds: 0,
        numberOfDoubleBeds: 0,
        numberOfSingleBeds: 0,
        numberOfTotalBeds: 0,
        searchKey: '',
        categoryCode: '',
        extendedDescription: '',
        totalArea: ''
    }

    validationSchema = Yup.object().shape({
        roomTypeCode: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(6, 'Maximum 6 characters allowed')
            .matches(FormConst.PATTERN_ALPHANUMERIC, 'Must be alpha numeric')
            .test('roomTypeCode should not be in existing room type codes', 'Duplicate room type code', (roomTypeCode) => !this.state.existingRoomTypeCodes?.includes(roomTypeCode)),
        numberOfRooms: Yup.number()
            .typeError('Must be a number')
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(1, 'Minimum value is 1')
            .max(this.props.history.location?.state?.maximumAllowedRoomCount, `Only ${this.props.history.location?.state?.maximumAllowedRoomCount} pending`),
        maxOccupancy: Yup.number()
            .typeError('Must be a number')
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(1, 'Minimum value is 1'),
        numberOfTotalBeds: Yup.number()
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(1, 'Min count is 1'),
        extendedDescription: Yup.string()
            .max(FormConst.EXTENDED_DESCRIPTION_MAXIMUM_LENGTH,
                `Maximum ${FormConst.EXTENDED_DESCRIPTION_MAXIMUM_LENGTH} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        totalArea: Yup.number()
            .typeError('Must be a number')
            .min(1, 'Minimum value is 1')
            .max(99999, 'Maximum value is 99999'),
    })

    getInitialValues = (roomType) => {
        const bedTypes = roomType.bedTypes

        let numberOfKingBeds = 0
        let numberOfQueenBeds = 0
        let numberOfDoubleBeds = 0
        let numberOfSingleBeds = 0
        let numberOfTotalBeds = 0

        if (isArrayNotEmpty(bedTypes)) {
            const kingBeds = searchFirstObjectInList('kind', 'King', bedTypes)
            if (!isObjectEmpty(kingBeds)) {
                numberOfKingBeds = Number(kingBeds.numberOfBeds)
            }

            const queenBeds = searchFirstObjectInList('kind', 'Queen', bedTypes)
            if (!isObjectEmpty(queenBeds)) {
                numberOfQueenBeds = Number(queenBeds.numberOfBeds)
            }

            const doubleBeds = searchFirstObjectInList('kind', 'Double', bedTypes)
            if (!isObjectEmpty(doubleBeds)) {
                numberOfDoubleBeds = Number(doubleBeds.numberOfBeds)
            }

            const singleBeds = searchFirstObjectInList('kind', 'Single', bedTypes)
            if (!isObjectEmpty(singleBeds)) {
                numberOfSingleBeds = Number(singleBeds.numberOfBeds)
            }

            numberOfTotalBeds = numberOfKingBeds + numberOfQueenBeds + numberOfDoubleBeds + numberOfSingleBeds
        }

        let initialValues = {
            roomTypeCode: roomType.hotelRoomTypeCode,
            roomCategory: roomType.roomCategory ? roomType.roomCategory : FormConst.DEFAULT_ROOM_TYPE,
            numberOfRooms: roomType.roomCount,
            maxOccupancy: roomType.maxOccupancy,
            accessible: roomType.accessible ? (FormConst.ACCESSIBILITY_VALUES_LIST.includes(roomType.accessible) ? true : false) : false,
            suite: roomType.suite,
            smoking: roomType.smoking === true ? true : false,
            extraBedAllowed: roomType.extraBedAllowed === true ? true : false,
            efficiency: roomType.efficiency,
            numberOfKingBeds: numberOfKingBeds,
            numberOfQueenBeds: numberOfQueenBeds,
            numberOfDoubleBeds: numberOfDoubleBeds,
            numberOfSingleBeds: numberOfSingleBeds,
            numberOfTotalBeds: numberOfTotalBeds,
            extendedDescription: roomType.extendedDescription ? roomType.extendedDescription : '',
            totalArea: roomType.area && roomType.area.value ? roomType.area.value : ''
        }
        return initialValues
    }

    getInitialValuesForRoomAmenities = (roomType) => {

        let initialValuesForRoomAmenities = {
            searchKey: '',
            categoryCode: '',
            selectedRoomAmenities: roomType.roomAmenities || [],
            addIndices: [],
            removeIndices: [],
            optionsList: [],
            filteredList: undefined,
            filterOptions: [{ label: '', value: '' }]
        }
        return initialValuesForRoomAmenities
    }

    async componentDidMount() {
        let tagSpecificAmenities = []
        let masterRoomAmenities = []
        await RoomTypesService.getMasterRoomAmenities({
            hotelCode: this.state.hotelCode, queryParams: {
                searchByTags: true
            }
        }).then(async tagSpecificAmenitiesResponse => {
            tagSpecificAmenities = tagSpecificAmenitiesResponse.masterRoomAmenities
            await RoomTypesService.getMasterRoomAmenities({
                hotelCode: this.state.hotelCode
            }).then(async masterAmenitiesResponse => {
                masterRoomAmenities = masterAmenitiesResponse.masterRoomAmenities

                // Amenities already present on the room type
                // If there are no amenities, tag specific amenities will be used by default
                let selectedRoomAmenities = this.state.isEdit ? this.state.initialValuesForRoomAmenities.selectedRoomAmenities : [...tagSpecificAmenities]
                let amenityCategories = {}
                // Push tag specific amenities into master list
                if (isArrayNotEmpty(tagSpecificAmenities)) {
                    // tagSpecificAmenities.forEach(amenity => masterHotelAmenities.push(amenity))
                    masterRoomAmenities = [...tagSpecificAmenities, ...masterRoomAmenities]
                }

                if (isArrayNotEmpty(masterRoomAmenities)) {
                    // String to be used for padding
                    const spaces = Array(10).join(StringConst.NBSP)

                    masterRoomAmenities.forEach((amenity, index) => {
                        if(amenity.code === DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE) {
                            return;
                        }
                        // Set value to the index in this list so that it will be unique when used in any other list - unselected or selected
                        amenity.value = index
                        // Add a label to be used while displaying in the select list for unselected amenities
                        amenity.label = pad(spaces, amenity.code, false) + amenity.description
                        // Set amenityCode - property in outgoing request for code
                        amenity.amenityCode = amenity.code
                        // Determine if charge can be applied
                        if (amenity.chargePolicy === 'Charge cannot be applied') {
                            amenity.isChargeApplicable = false
                        } else {
                            amenity.isChargeApplicable = true
                        }
                        // Add amenity category to filter options list
                        if (amenity.amenityCategory) {
                            amenityCategories[amenity.amenityCategory.code] = amenity.amenityCategory.description
                        }
                    })

                    // Calculate amenity categories list
                    let amenityCategoriesList = [{ label: '', value: '' }]

                    let accessibleCategories = []
                    let otherCategories = []

                    // Get accessible and other categories
                    for (const key in amenityCategories) {
                        if (amenityCategories.hasOwnProperty(key)) {
                            const element = amenityCategories[key]
                            if (element?.toUpperCase().includes('ACCESSIBLE')) {
                                accessibleCategories.push({ label: element, value: key })
                            } else {
                                otherCategories.push({ label: element, value: key })
                            }
                        }
                    }

                    // Add accessible categories first
                    if (isArrayNotEmpty(accessibleCategories)) {
                        amenityCategoriesList = [...amenityCategoriesList, ...accessibleCategories]
                    }

                    // Add other cateories
                    if (isArrayNotEmpty(otherCategories)) {
                        sortObjectList(otherCategories, 'label')
                        amenityCategoriesList = [...amenityCategoriesList, ...otherCategories]
                    }

                    // Get all options from master room amenities
                    let options = masterRoomAmenities.filter((amenity) => !searchObjectListBoolean('code', amenity.code, selectedRoomAmenities))
                    options = sortObjectList(options, 'code')
                    selectedRoomAmenities?.forEach(amenity => {
                        let amenityInMaster = searchFirstObjectInList('code', amenity.code, masterRoomAmenities)
                        amenity.value = amenityInMaster.value
                        amenity.label = amenityInMaster.label

                        if (amenityInMaster.chargePolicy === 'Charge cannot be applied') {
                            amenity.isChargeApplicable = false
                        } else {
                            amenity.isChargeApplicable = true
                        }
                        amenity.chargable = amenity.chargable ? 'true' : 'false'
                    })
                    selectedRoomAmenities = sortObjectList(selectedRoomAmenities, 'amenityCode')

                    let maxOccupancy = this.calculateMaxOccupancy(this.state.initialValues, selectedRoomAmenities)

                    this.setState({
                        isLoading: false,
                        // Master list of amenities
                        masterRoomAmenities: masterRoomAmenities,
                        // Tag specific amenities list
                        tagSpecificAmenities: tagSpecificAmenities,
                        initialValuesForRoomAmenities: {
                            ...this.state.initialValuesForRoomAmenities,
                            searchKey: '',
                            categoryCode: '',
                            // Selected room amenities
                            selectedRoomAmenities: selectedRoomAmenities,
                            // All possible options list
                            optionsList: options,
                            // Used when a filter is applied to display filtered options
                            filteredList: undefined,
                            // Category filter options
                            filterOptions: amenityCategoriesList
                        },
                        initialValues: {
                            ...this.state.initialValues,
                            maxOccupancy: maxOccupancy
                        }
                    })
                }

            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while retrieving Room Amenities'
                })
            })
        }).catch(error => {
            this.setState({
                isLoading: false,
                showErrorModal: true,
                errorMessage: 'There was an error while retrieving Room Amenities'
            })
        })
    }

    handleSubmit = (formData) => {
        let newRoomType = {
            masterRoomTypeCode: this.state.masterRoomTypeCode,
            hotelRoomTypeCode: formData.roomTypeCode,
            roomCategory: formData.roomCategory,
            maxOccupancy: formData.maxOccupancy,
            roomCount: formData.numberOfRooms,
            extraBedAllowed: formData.extraBedAllowed,
            extendedDescription: formData.extendedDescription,
            area: { value: formData.totalArea }
        }

        let putRoomAmenities = []

        if (isArrayNotEmpty(this.state.initialValuesForRoomAmenities.selectedRoomAmenities)) {
            putRoomAmenities = this.state.initialValuesForRoomAmenities.selectedRoomAmenities.map((roomAmenity, index) => {
                return {
                    code: roomAmenity.code,
                    description: roomAmenity.description,
                    chargable: roomAmenity.chargable === 'true' ? true : false,
                    amenitySortIndex: (index + 1).toString()
                }
            })
        }

        newRoomType.roomAmenities = putRoomAmenities
        let newRoomTypes = this.state.roomTypes.length > 0 ? [...this.state.roomTypes] : []
        const queryParams = {
            smoking: formData.smoking,
            accessibility: formData.accessible,
            suite: formData.suite,
            efficiency: formData.efficiency
        }

        if (formData.numberOfKingBeds) {
            queryParams['King'] = formData.numberOfKingBeds
        }
        if (formData.numberOfQueenBeds) {
            queryParams['Queen'] = formData.numberOfQueenBeds
        }
        if (formData.numberOfDoubleBeds) {
            queryParams['Double'] = formData.numberOfDoubleBeds
        }
        if (formData.numberOfSingleBeds) {
            queryParams['Single'] = formData.numberOfSingleBeds
        }
        this.props.onGetMasterRoomType({ hotelCode: this.state.hotelCode, queryParams: queryParams })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT, pendingRoomType: newRoomType, pendingRoomTypes: newRoomTypes })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    componentDidUpdate(prevProps) {

        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.GET_MASTER_ROOM_TYPE) {
                    if (isArrayNotEmpty(this.props.roomTypesResponse)) {
                        const masterRoomTypeCode = this.props.roomTypesResponse[0].code
                        const putRoomTypes = [...this.state.pendingRoomTypes]
                        const newRoomType = { ...this.state.pendingRoomType, masterRoomTypeCode: masterRoomTypeCode }

                        if (this.state.isEdit) {
                            putRoomTypes[this.state.editIndex] = newRoomType
                        } else {
                            putRoomTypes.push(newRoomType)
                        }
                        this.props.onPut({ hotelCode: this.state.hotelCode, roomTypes: putRoomTypes })
                        this.setState({ isLoading: true })
                        // Call put
                    } else {
                        this.setState({
                            isLoading: false,
                            showErrorModal: true,
                            errorMessage: 'No matching room types found for the provided attributes'
                        })
                    }
                } else {
                    this.props.history.push(RouteConst.ROUTE_ROOM_TYPES_PAGE)
                }
            }
        }
    }

    handleErrorModalCancel = () => {
        this.setState({ isLoading: false })
    }

    /**
     * Updates the initialValues and maxOccupancy every time a change on the Bed Type Count is made
     * or any other initialValues field
     * @param value the current value of the field
     * @param field the name of the field to match with the initial values
     */
    updateInitialValues = (value, field) => {
        let initialValues = {...this.state.initialValues}
        initialValues[field] = value
        let maxOccupancy = this.calculateMaxOccupancy(initialValues, this.state.initialValuesForRoomAmenities.selectedRoomAmenities);
        initialValues.maxOccupancy = maxOccupancy
        this.setState({
            initialValues : {...initialValues}
        })
    }

    /**
     * Determinate the maxOccupancy depending on the type of beds and amenities provided
     * @param initialValues
     * @param selectedRoomAmenities
     * @returns {number}
     */
    calculateMaxOccupancy = (initialValues, selectedRoomAmenities) => {

        let zero = Number(0);
        let maximumAllowed = Number(0);

        // Depending on the type of bed is the maxOccupancy we are going to add
        maximumAllowed += initialValues.numberOfKingBeds   ? initialValues.numberOfKingBeds * 2 : zero;
        maximumAllowed += initialValues.numberOfQueenBeds  ? initialValues.numberOfQueenBeds * 2 : zero;
        maximumAllowed += initialValues.numberOfDoubleBeds ? initialValues.numberOfDoubleBeds * 2 : zero;
        maximumAllowed += initialValues.numberOfSingleBeds ? Number(initialValues.numberOfSingleBeds) : zero;

        let filteredSelected = selectedRoomAmenities.filter(amenity => ROOM_TYPE_AMENITIES_CODES_MAX_OCCUPANCY.includes(amenity.code))
        filteredSelected.forEach( amenity => {
            let roomTypeAmenity = ROOM_TYPE_AMENITIES_MAX_OCCUPANCY.find( roomType => roomType.code === amenity.code);
            maximumAllowed += Number(roomTypeAmenity.value);
        })

        return maximumAllowed;
    }

    addAmenity = (valueList, selectedRoomAmenities) => {
        let values = valueList.map(index => {
            return Number(index)
        })

        let options = [...this.state.initialValuesForRoomAmenities.optionsList]

        let entriesToAdd = options.filter(option => values.includes(option.value))

        let remainingOptions = this.state.initialValuesForRoomAmenities.optionsList.filter(option => !values.includes(option.value))
        let fitleredList = this.state.initialValuesForRoomAmenities.filteredList?.filter(option => !values.includes(option.value))

        entriesToAdd.forEach(entry => {
            entry.chargable = 'false'
        })

        let selected

        if (isArrayNotEmpty(selectedRoomAmenities)) {
            selected = [...selectedRoomAmenities, ...entriesToAdd]
        } else {
            selected = [...entriesToAdd]
        }

        valueList.splice(0, valueList.length)

        let maxOccupancy = this.calculateMaxOccupancy(this.state.initialValues, selected);

        let initialValuesForRoomAmenities = {
            ...this.state.initialValuesForRoomAmenities,
            optionsList: remainingOptions,
            selectedRoomAmenities: selected,
            addIndices: valueList,
            filteredList: fitleredList,
        }

        this.setState({
            initialValuesForRoomAmenities: initialValuesForRoomAmenities,
            minRoomAmenitiesLimitReached: false,
            initialValues: {
                ...this.state.initialValues,
                maxOccupancy: maxOccupancy
            }
        })
    }

    removeAmenity = (amenityCode, valueList, selectedRoomAmenities) => {
        let values = valueList.map(index => {
            return Number(index)
        })

        let selected = [...selectedRoomAmenities]

        if (selected && selected.length == FormConst.MIN_ROOM_TYPE_AMENITIES){
            this.setState({
                minRoomAmenitiesLimitReached: true
            })
            return
        }

        let entriesToRemove
        let remainingSelected
        let options

        if(amenityCode === DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE) {
            entriesToRemove = selected.filter(option => option.code === DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE)
            remainingSelected = selected.filter(option => option.code !== DEFAULT_HIDDEN_AMENITY_FOR_ROOM_TYPE)
            options = [...this.state.initialValuesForRoomAmenities.optionsList]
        } else {
            entriesToRemove = selected.filter(option => values.includes(option.value))
            remainingSelected = selected.filter(option => !values.includes(option.value))
            options = [...entriesToRemove, ...this.state.initialValuesForRoomAmenities.optionsList]
        }

        let maxOccupancy = this.calculateMaxOccupancy(this.state.initialValues, remainingSelected)

        let initialValuesForRoomAmenities = {
            ...this.state.initialValuesForRoomAmenities,
            selectedRoomAmenities: remainingSelected,
            optionsList: options,
            filteredList: undefined,
            searchKey: '',
            categoryCode: ''
        }

        this.setState({
            initialValuesForRoomAmenities: initialValuesForRoomAmenities,
            initialValues: {
                ...this.state.initialValues,
                maxOccupancy: maxOccupancy
            }
        })
    }

    handleRoomAmenitiesCharge = (value, index) => {
        this.state.initialValuesForRoomAmenities.selectedRoomAmenities[index].chargable = value;

        this.setState({
            initialValuesForRoomAmenities: {
                ...this.state.initialValuesForRoomAmenities
            }
        })
    }

    searchOptions = (searchKey, categoryCode) => {
        let filteredList

        if (!searchKey && !categoryCode) {
            // If no filter is present, return undefined
            filteredList = undefined
        } else {
            filteredList = [...this.state.initialValuesForRoomAmenities.optionsList]

            // If category filter is present, first filter using the category code
            if (categoryCode) {
                filteredList = filteredList.filter(option => option.amenityCategory.code === categoryCode)
            }

            // If search key is present, filter the remaining list with the key
            if (searchKey) {
                filteredList =
                    filteredList.filter(option => (option.code !== undefined && option.code.includes(searchKey))
                                 || (option.amenityCode !== undefined && option.amenityCode.includes(searchKey))
                                 || (option.description !== undefined && option.description.toUpperCase().includes(searchKey)))
            }
        }
        this.setState({
            initialValuesForRoomAmenities: {
                ...this.state.initialValuesForRoomAmenities,
                filteredList: filteredList,
                searchKey: searchKey,
                categoryCode: categoryCode
            }
        })
    }

    render() {
        let helperText

        if (this.state.selectedRoomAmenities === undefined || this.state.selectedRoomAmenities.length === 0) {
            helperText = 'These room amenities were pre-selected based on your brand.'
        } else {
            helperText = 'These are the currently selected room amenities.'
        }

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting }) => {
                    
                    const checklist = this.props.checklist
                    let isCompleteInChecklist = false
                    if (isArrayNotEmpty(checklist)) {
                        isCompleteInChecklist = searchFirstObjectInList('code', 'BASE_RATE_PLAN', checklist)?.processedFlag === FormConst.CHECKLIST_STATUS_COMPLETED
                    }
                    if (isCompleteInChecklist && !this.state.isEdit) {
                        this.setState({
                            showWarningModal: true,
                            pendingFormData: data
                        })
                    } else {
                        setSubmitting(true)
                        this.handleSubmit(data)
                    }
                    setSubmitting(false)
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, handleChange, resetForm }) => (
                        <Form className='room-types-form-element'>
                            <div className='room-type-form-fields'>
                                <nav aria-label='breadcrumb'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_ROOM_TYPES_PAGE}>Room Types</NavLink></li>
                                        <li className='breadcrumb-item active' aria-current='page'>Room Type</li>
                                    </ol>
                                </nav>
                                <p className='room-type-heading'>Room Type Details</p>
                                <p className='form-helper-text'>Enter room type details.</p>
                                {/* Initial fields */}
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={6}>
                                        <TextInput
                                            id='room-type-code'
                                            type='text'
                                            label='Room Type Code'
                                            name='roomTypeCode'
                                            onChange={(e) => {
                                                e.preventDefault();
                                                this.updateInitialValues(e.target.value.toUpperCase(), 'roomTypeCode');
                                                handleChange(e);
                                            }}
                                            isrequired='true' />
                                        {
                                            isArrayNotEmpty(this.state.existingRoomTypeCodes)
                                            && <p className='helper-text mt-3 mb-0'>Existing room type codes: {this.state.existingRoomTypeCodes.join(', ')}</p>
                                        }
                                        <Button
                                            id='examples-widget-link'
                                            role='link'
                                            name={this.state.showExamples ? 'Hide Examples' : 'Show Examples'}
                                            onClick={() => this.setState({ showExamples: !this.state.showExamples })} />
                                        {
                                            this.state.showExamples
                                            && <Card id='examples-widget'
                                                header={
                                                    <>
                                                        Room Type Code Examples
                                                        <button
                                                            id='close-button'
                                                            type='button'
                                                            className='close mr-auto'
                                                            aria-label='Close'
                                                            onClick={() => this.setState({ showExamples: false })}>
                                                            <span aria-hidden='true'>&times;</span>
                                                        </button>
                                                    </>
                                                }
                                                text={
                                                    <>
                                                        Common Room Type Codes:
                                                    <ul>
                                                            <li>K (1 king bed/smoking)</li>
                                                            <li>NK (1 king bed/nonsmoking)</li>
                                                            <li>SNK (Suite 1 king bed/non-smoking)</li>
                                                            <li>ENK (king bed/nonsmoking with Kitchenette)</li>
                                                            <li>NHQ (1 queen bed/nonsmoking handicapped accessible)</li>
                                                            <li>QQ (2 queen beds/smoking)</li>
                                                            <li>NQQ (2 queen beds/non-smoking)</li>
                                                            <li>DD (2 double beds/smoking)</li>
                                                            <li>NDD (2 double beds/non-smoking)</li>
                                                            <li>NQ1 (1 queen bed/non-smoking/specialty)</li>
                                                        </ul>
                                                    If you have questions or need assistance determining room type codes, please contact your {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
                                                </>
                                                } />
                                        }
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={6}>
                                        {
                                            EnvVarsConst.ROOM_CATEGORY_ENABLED &&
                                        <SelectInput id='room-category' name='roomCategory'
                                                     label='Room Category'
                                                     options={FormConst.ROOM_CATEGORY_OPTIONS}
                                                     isrequired='true'
                                                     onChange={(e) => {
                                                         e.preventDefault();
                                                         this.updateInitialValues(e.target.value, 'roomCategory');
                                                         handleChange(e);
                                                     }}/>
                                        }
                                        <TextInput id='number-of-rooms' type='number' label='Number of Rooms' name='numberOfRooms' isrequired='true' min={1} max={this.state.maximumAllowedRoomCount}
                                                   onChange={(e) => {
                                                       e.preventDefault();
                                                       this.updateInitialValues(e.target.value, 'numberOfRooms');
                                                       handleChange(e);
                                                   }}/>
                                        <TextInput id='max-occupancy' type='number' label='Max Occupancy' name='maxOccupancy' isrequired='true' disabled min={1} />

                                        <TextInput id='max-occupancy' type='number' label='Total Area' name='totalArea' suffix={this.state.areaUnits} 
                                        onChange={(e) => {
                                            e.preventDefault();
                                            this.updateInitialValues(e.target.value, 'totalArea');
                                            handleChange(e);
                                        }}/>
                                    </Col>

                                </Row>

                               {/* Attributes */}
                               <Row className='master-room-type-filters'>
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} className='attributes-column'>
                                        <h6 className='room-type-heading'>Attributes</h6>
                                        <ToggleSwitch
                                            id='accessible'
                                            name='accessible'
                                            label='Accessible'
                                            checked={values.accessible}
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onClick={(e) => {
                                                this.updateInitialValues(!values.accessible, 'accessible');
                                            }}
                                            onChange={handleChange}
                                        />
                                        <ToggleSwitch
                                            id='suite'
                                            name='suite'
                                            label='Suite'
                                            checked={values.suite}
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onClick={(e) => {
                                                this.updateInitialValues(!values.suite, 'suite');
                                            }}
                                            onChange={handleChange}
                                        />
                                        <ToggleSwitch
                                            id='extraBedAllowed'
                                            name='extraBedAllowed'
                                            label='Extra Bed'
                                            checked={values.extraBedAllowed}
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onClick={(e) => {
                                                this.updateInitialValues(!values.extraBedAllowed, 'extraBedAllowed');
                                            }}
                                            onChange={handleChange}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} className='attributes-column'>
                                        <h6 className='room-type-heading'>{StringConst.NBSP}</h6>
                                        <ToggleSwitch
                                            id='smoking'
                                            name='smoking'
                                            label='Smoking'
                                            checked={values.smoking}
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onClick={(e) => {
                                                this.updateInitialValues(!values.smoking, 'smoking');
                                            }}
                                            onChange={handleChange}
                                        />
                                        <ToggleSwitch
                                            id='efficiency'
                                            name='efficiency'
                                            label='Efficiency'
                                            checked={values.efficiency}
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onClick={(e) => {
                                                this.updateInitialValues(!values.efficiency, 'efficiency');
                                            }}
                                            onChange={handleChange}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} xl={6} className='bed-types-column'>
                                        <h6 className='room-type-heading'>Bed Types Count</h6>
                                        <p className='bed-types-helper-text'>** At least one bed type count is required.</p>
                                        <TextInput id='king-beds-count' type='number' label='# King Beds' name='numberOfKingBeds' isdependent='true' min={0}
                                             onChange={(e) => {
                                             e.preventDefault();
                                             this.updateInitialValues(e.target.value, 'numberOfKingBeds');
                                             handleChange(e);
                                        }}/>
                                        <TextInput id='queen-beds-count' type='number' label='# Queen Beds' name='numberOfQueenBeds' isdependent='true' min={0}
                                                   onChange={(e) => {
                                                       e.preventDefault();
                                                       this.updateInitialValues(e.target.value, 'numberOfQueenBeds');
                                                       handleChange(e);
                                        }}/>
                                        <TextInput id='double-beds-count' type='number' label='# Double Beds' name='numberOfDoubleBeds' isdependent='true' min={0}
                                                   onChange={(e) => {
                                                       e.preventDefault();
                                                       this.updateInitialValues(e.target.value, 'numberOfDoubleBeds');
                                                       handleChange(e);
                                        }}/>
                                        <TextInput id='single-beds-count' type='number' label='# Single Beds' name='numberOfSingleBeds' isdependent='true' min={0}
                                                   onChange={(e) => {
                                                       e.preventDefault();
                                                       this.updateInitialValues(e.target.value, 'numberOfSingleBeds');
                                                       handleChange(e);
                                        }}/>
                                        <TextInput id='total-beds-count' type='number' label='# Total Beds' name='numberOfTotalBeds'
                                            value={values.numberOfTotalBeds =
                                                (values.numberOfKingBeds ? Number(values.numberOfKingBeds) : 0)
                                                + (values.numberOfQueenBeds ? Number(values.numberOfQueenBeds) : 0)
                                                + (values.numberOfDoubleBeds ? Number(values.numberOfDoubleBeds) : 0)
                                                + (values.numberOfSingleBeds ? Number(values.numberOfSingleBeds) : 0)
                                            }
                                            disabled min={1} />
                                        {this.state.filtersError && <p className='error bed-types-error'>{this.state.filtersError}</p>}
                                    </Col>
                                </Row>
                                <div className="extended-room-description">
                                    <p className='extended-room-description-heading'>Extended Room Description</p>
                                    <TextAreaInput
                                        id='extended-description-text'
                                        name='extendedDescription'
                                        rows={3}
                                        maxLength={FormConst.EXTENDED_DESCRIPTION_MAXIMUM_LENGTH}
                                        placeholder={FormConst.EXTENDED_DESCRIPTION_PLACEHOLDER_TEXT}
                                        style={{ width: '100%' }}
                                        overridedisabledflag='false'
                                        onChange={(e) => {
                                            e.preventDefault();
                                            this.updateInitialValues(e.target.value, 'extendedDescription');
                                            handleChange(e);
                                        }}
                                    />
                                    <p className='float-right'>Characters left: {FormConst.EXTENDED_DESCRIPTION_MAXIMUM_LENGTH - values.extendedDescription.length}</p>
                                </div>

                                {/* Room Amenities */}

                                <Formik
                                    initialValues={this.state.initialValuesForRoomAmenities}
                                    enableReinitialize={true}
                                    onSubmit={(data, { setSubmitting }) => {
                                        setSubmitting(true)
                                        this.handleSubmit(data)
                                        setSubmitting(false)
                                    }}>
                                    {
                                        ({ values, errors, touched, dirty, isSubmitting, isValid, handleChange, resetForm }) => (
                                            <div className='room-amenities'>
                                                <p className='room-type-heading'>Room Amenities</p>
                                                <p className='helper-text'>{`${helperText} You may deselect any that do not apply.`}</p>

                                                <Button
                                                    id='popular-amenities-widget-link'
                                                    role='link'
                                                    name={this.state.showPopularAmenities ? 'Hide Popular Room Amenities' : 'Show Popular Room Amenities'}
                                                    onClick={() => this.setState({ showPopularAmenities: !this.state.showPopularAmenities })} />
                                                {
                                                    this.state.showPopularAmenities
                                                    && <Card id='popular-amenities-widget'
                                                        header={
                                                            <>
                                                                Popular Room Amenities
                                                                <button
                                                                    id='close-button'
                                                                    type='button'
                                                                    className='close mr-auto'
                                                                    aria-label='Close'
                                                                    onClick={() => this.setState({ showPopularAmenities: false })}>
                                                                    <span aria-hidden='true'>&times;</span>
                                                                </button>
                                                            </>
                                                        }
                                                        text={
                                                            <Row>
                                                                <Col xs={12} lg={6}>
                                                                    <b>Popular Amenities</b>
                                                                    <ul>
                                                                        <li>FHSW (Free Hi-Speed Wireless)</li>
                                                                        <li>MICR (Microwave)</li>
                                                                        <li>FRIG (Refrigerator)</li>
                                                                        <li>FLAT (Flat Screen TV)</li>
                                                                        <li>42TV (42 in TV)</li>
                                                                        <li>RMCF (Coffeemaker in Room)</li>
                                                                        <li>HAIR (Hair Dryer)</li>
                                                                        <li>IRON (Iron &amp; Ironing Board)</li>
                                                                        <li>DERG (Desk with Ergonomic Chair)</li>
                                                                        <li>TABL (Table with Chairs)</li>
                                                                        <li>INSF (In Room Safe)</li>
                                                                        <li>HBO (HBO)</li>
                                                                        <li>PILO (Pillowtop Mattress)</li>
                                                                        <li>RACL (Radio Alarm Clock)</li>
                                                                        <li>RCHG (Recharge Device)</li>
                                                                    </ul>
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <b>Suites</b>
                                                                    <ul>
                                                                        <li>1RMS (1 Room Suite)</li>
                                                                        <li>1BRM (Suite with separate bedroom - wall and door)</li>
                                                                        <li>SFBD (Sofabed)</li>
                                                                        <li>DIVR (Divider Wall)</li>
                                                                        <li>SITG (Sitting Area)</li>
                                                                    </ul>
                                                                    <b>Special Rooms</b>
                                                                    <ul>
                                                                        <li>KTCH (Kitchenette)</li>
                                                                        <li>2PWP (2 Person Whirlpool)</li>
                                                                    </ul>
                                                                </Col>
                                                            </Row>
                                                        } />
                                                }

                                                <Row className='d-flex justify-content-start room-amenities-fields'>
                                                    <Col xs={12} sm={12} xl={4}>
                                                        <TextInput name='searchKey' id='search-key' placeholder='Search...' label='Search:' title='Search'
                                                            onInput={(e) => {
                                                                e.preventDefault()
                                                                this.searchOptions(e.target.value.toUpperCase(), values.categoryCode)
                                                            }
                                                            } />
                                                        <SelectInput name='categoryCode' id='filter-key' label='Filter by category:' title='Filter by category'
                                                            options={values.filterOptions}
                                                            onChange={(e) => {
                                                                e.preventDefault()
                                                                // values.categoryCode = e.target.value
                                                                this.searchOptions(values.searchKey, e.target.value)
                                                            }
                                                            } />
                                                        <SelectList
                                                            name='addIndices'
                                                            id='selected-input'
                                                            label='Unselected amenities:'
                                                            size='10'
                                                            className='unselected-amenities'
                                                            options={values.filteredList ? values.filteredList : values.optionsList}
                                                            title='Unselected amenities' />
                                                    </Col>
                                                    <Col xs={12} sm={12} xl={1} className='text-center p-0 add-remove-buttons'>
                                                        <Button name='Add >>' onClick={() => {
                                                            this.addAmenity(values.addIndices, values.selectedRoomAmenities)
                                                        }
                                                        } />
                                                    </Col>
                                                    <Col xs={12} sm={12} xl={7} className='align-self-start'>
                                                        <table className='table table-striped selected-amenities-table'>
                                                            <caption>
                                                                Selected Room Amenities
                                                                <h6 className='text-red mt-1 mb-1'>Please make sure that you add your Accessible Room amenities.</h6>
                                                            </caption>
                                                            <thead>
                                                                <tr>
                                                                    {this.headers.map((header, index) => {
                                                                        return <th key={header} index={`header-${index}`}>{header}</th>
                                                                    })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {values.selectedRoomAmenities.length > 0 ?
                                                                    values.selectedRoomAmenities.map((amenity, index) => {
                                                                        return (
                                                                            <tr key={index} className='align-items-center'>
                                                                                <td>{amenity.code}</td>
                                                                                <td>{amenity.description}</td>
                                                                                <td><SelectInput
                                                                                    id={`charge-${index}`}
                                                                                    name={`selectedRoomAmenities.${index}.chargable`}
                                                                                    options={FormConst.OPTIONS_YES_NO_BOOLEAN}
                                                                                    disabled={!values.selectedRoomAmenities[index].isChargeApplicable}
                                                                                    isrequired='true'
                                                                                    onChange={(e) => {
                                                                                        e.preventDefault()
                                                                                        this.handleRoomAmenitiesCharge(e.target.value, index)
                                                                                    }}
                                                                                    title='Charge'
                                                                                    /></td>
                                                                                <td>
                                                                                    <a onClick={() => {
                                                                                        this.removeAmenity(amenity.code, [amenity.value], values.selectedRoomAmenities)
                                                                                    }}>
                                                                                        <FaTrashAlt />
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        )

                                                                    })
                                                                    : <tr>
                                                                        <td colSpan='4' className='text-center'>
                                                                            There are no selected amenities
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                        {
                                                            (this.state.minRoomAmenitiesLimitReached) ? <p className='text-center error mt-3 mb-0'>{FormConst.MIN_ROOM_TYPE_AMENITIES_MESSAGE}</p> : ''
                                                        }
                                                    </Col>
                                                </Row>
                                                <FormModal
                                                    id='room-type-page-delete-modal'
                                                    title='Delete All Amenities'
                                                    hotelInfo={this.state.hotelInfo}
                                                    body={<h6>{FormConst.MODAL_DELETE_ACTION_TEXT}</h6>}
                                                    proceed={() => {
                                                        this.removeAmenity('', values.selectedRoomAmenities.map(amenity => amenity.value),
                                                            values.selectedRoomAmenities)
                                                        this.setState({ showDeleteModal: false })
                                                    }}
                                                    cancel={() => { this.setState({ showDeleteModal: false }) }}
                                                    show={this.state.showDeleteModal} />
                                            </div>
                                        )
                                    }
                                </Formik>
                            </div>
                            {/* Form Footer */}
                            <FormFooter
                                form={SideNavEntryMapping.ROOM_TYPES}
                                isSubmit
                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                noReset
                                submitDisabled={isSubmitting} />
                            {/* Form Modals */}
                            <FormModal
                                id='room-type-page-loading-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='room-type-page-reset-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.resetFormData(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='room-type-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                            <FormModal
                                id='room-type-page-rates-complete-warning-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_TITLE}
                                body={<h5>{FormConst.MODAL_ROOM_TYPE_ADD_WARNING}</h5>}
                                proceed={() => {
                                    this.setState({ showWarningModal: false })
                                    this.handleSubmit(this.state.pendingFormData)
                                }}
                                cancel={() => { this.setState({ showWarningModal: false }) }}
                                show={this.state.showWarningModal} />
                        </Form>
                    )}
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        roomTypesResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onGetMasterRoomAmenities: (hotelCode) => dispatch(asyncMethod(FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET_MASTER_ROOM_AMENITIES, { hotelCode: hotelCode })),
        onGetBrandSpecificMasterRoomAmenities: (hotelCode) => dispatch(asyncMethod(FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET_BRAND_SPECIFIC_MASTER_ROOM_AMENITIES, { hotelCode: hotelCode })),
        onGetMasterRoomType: (data) => dispatch(asyncMethod(FormConst.FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET_MASTER_ROOM_TYPE, data)),
        onPut: (data) => dispatch(asyncMethod(FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(RoomType, SideNavEntryMapping.ROOM_TYPES))